import React from "react";
import { useLocation, useParams } from "react-router-dom";
import getParams from "utils/getParams";

import HasValidInvite from "components/HasValidInvite";
import AcceptClientInvite from "pages/ClientInvite/AcceptClientInvite";

interface ClientInviteParams {
  inviteId: string;
}

export const ClientInvite: React.FC = () => {
  const { inviteId } = useParams<ClientInviteParams>();
  const params = getParams(useLocation().search);

  return (
    <HasValidInvite inviteId={inviteId} validateUser={true}>
      <AcceptClientInvite inviteId={inviteId} params={params} />
    </HasValidInvite>
  );
};
